// extracted by mini-css-extract-plugin
export default {"dashboardWrapper":"PunchupDashboard_dashboardWrapper__MlWBf","accordionDisabled":"PunchupDashboard_accordionDisabled__fcEAf"};